/* eslint-disable consistent-return */
import api from 'services/api';
import { toast } from 'react-toastify';
import axios from 'axios';
import {
  buildResendSuccessMessage,
  buildSendSuccessMessage,
  GENERIC_ERROR_MESSAGE,
  SEND_FAILURE_MESSAGE,
} from './messages';

const TOKEN_ERROR_MIN_STATUS = 400;

export const requestGetAccessToken = async () => {
  const req = axios.create({
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Accept-Language': 'pt-BR',
      client_id: process.env.REACT_APP_CLIENT_ID,
    },
    baseURL: process.env.REACT_APP_API_URL_OAUTH,
  });

  const header = {
    'Content-Type': 'application/json',
    'Accept-Language': 'pt-BR',
    Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  };

  const body = {
    grant_type: 'client_credentials',
  };

  let access_token = '';

  try {
    const response = await req.post('oauth/access-token', body, parameters);
    access_token = response.data.access_token;
  } catch (error) {
    const erro = error.response;

    if (erro) {
      const { message } = error.response.data;

      if (error.response.status !== 401) {
        toast.error(message);
      }
    } else if (error.response.status !== 401) {
      toast.error('Ocorreu um erro interno na aplicação');
    }
  }

  return access_token;
};

export const validationToken = async (token, userId) => {
  const headers = {
    access_token: await requestGetAccessToken(),
  };

  const bodyToken = {
    token,
  };

  let success;

  try {
    await api.post(
      `industrial/customer/v1/users/${userId}/validations`,
      bodyToken,
      {
        headers,
      }
    );
    success = true;
  } catch (error) {
    toast.error(error?.response?.data?.message ?? GENERIC_ERROR_MESSAGE);
    success = false;
  }

  return success;
};

export const sendToken = async (contact, userId, contactId = null) => {
  const headers = {
    access_token: await requestGetAccessToken(),
  };
  const bodyToken = {
    tokenType: 'MFA',
    contactId: contact?.contactId || contactId,
    url: null,
  };

  try {
    const response = await api.post(
      `industrial/customer/v1/users/${userId}/tokens`,
      bodyToken,
      {
        headers,
      }
    );

    if (response?.status >= TOKEN_ERROR_MIN_STATUS) {
      toast.error(SEND_FAILURE_MESSAGE);
      return false;
    }

    if (contact?.contact) {
      toast.warn(
        contactId
          ? buildResendSuccessMessage(contact)
          : buildSendSuccessMessage(contact)
      );
    }

    return true;
  } catch (error) {
    toast.error(SEND_FAILURE_MESSAGE);
    return false;
  }
};

const requestUserContacts = async (userId, data) => {
  try {
    const response = await api.get(
      `industrial/customer/v1/users/${userId}/contacts?mfa-eligible=true`
    );

    const resposeData = { ...data, contacts: response.data, userId };
    return resposeData;
  } catch (error) {
    const erro = error.response;

    if (erro) {
      const { message } = error.response.data;

      if (error.response.status !== 401) {
        toast.error(message);
      }
    } else if (error.response.status !== 401) {
      toast.error('Ocorreu um erro interno na aplicação');
    }
  }
};

export const requestGetUserById = async (userId) => {
  try {
    const responseUserContacts = await requestUserContacts(userId, []);
    if (!userId && responseUserContacts === undefined) {
      throw new Error('Erro ao carregar os contatos!');
    }
    return responseUserContacts;
  } catch (error) {
    const erro = error.response;
    if (erro) {
      const { message } = error.response.data;

      if (error.response.status !== 401) {
        toast.error(message);
      }
    } else if (error.response.status !== 401) {
      toast.error('Ocorreu um erro interno na aplicação');
    }
  }
};
